<template>
  <div class="container mescroll-touch" id="toTop">
    <div class="navigationBar">
      <div class="nav-left">
        <img class="arrow-left" @click="goback" src="@/assets/images/arrow-left.png" />
      </div>
      <div class="nav-title">{{ title }}</div>
      <div class="nav-right" @click="showDepartment"> 
        <span>{{ selectDepartmentName ? selectDepartmentName : '所有科室' }}</span>
        <img src="@/assets/images/caretIcon_active.png" />
      </div>
      <van-popup v-model="showDepartmentPopover" round position="bottom" :style="{ height: '50%' }">
        <div class="pickerContent">
          <div class="van-picker__toolbar toolbar">
            <button type="button" class="van-picker__cancel" @click="onScreenCancel">取消</button>
            <button type="button" class="van-picker__confirm" @click="onScreenConfirm">确认</button>
          </div>
          <div class="picker_content">
            <div class="pickerBox">
              <div class="picker_block" :class="{ 'active': tempSelectDepartmentId == '' }" @click="selectDepartment('', '')">全部</div>
              <div class="picker_block" :class="{ 'active': tempSelectDepartmentId == item.Id }" v-for="(item, index) in departmentList" :key="index" @click="selectDepartment(item.Id, item.Name)">{{item.Name}}</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="list" id="dataList">
        <template v-if="type == 1">
          <div class="item" v-for="(item, index) in list" :key="index" @click="toZoneDetails(item.ZDId, item.Id)">
            <img class="cover" :src="item.Kv" />
            <div class="info">
              <p class="title">{{ item.Name }}</p>
              <p class="time">{{ item.StartTime | timeQuantum(item.EndTime) }}</p>
              <button class="viewBtn">查看</button>
            </div>
          </div>
        </template>

        <template v-if="type == 2">
          <div class="item1" v-for="(item, index) in list" :key="index">
            <div class="titleBox" @click="toZoneDetails(item.ZDId, item.Id)">
              <span class="title">{{ item.Name }}</span>
              <span class="enter">进入专区<van-icon name="arrow" /></span>
            </div>
            <div class="relatedContent">
              <div class="relatedItem" v-for="(contentItem, contentIndex) in item.artLst" :key="contentIndex" @click="contentClick(contentItem, item.Id)">
                <img class="cover" :src="contentItem.Thumbnail" />
                <div class="info">
                  <div class="title">{{ contentItem.Title }}</div>
                  <div class="doctor" v-if=" contentItem.Speaker">{{ contentItem.Speaker }} | {{ contentItem.HospitalName }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  name: 'ZonePage',
  data() {
    return {
      hasPath: '',
      title: '',
      type: '',
      list: [],
      PageIndex: 0,
      PageSize: 6,
      Total: 0,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 6 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        },
			},
      showDepartmentPopover: false,
      departmentList: [],
      selectDepartmentId: '',
      tempSelectDepartmentId: '',
      selectDepartmentName: '',
      tempSelectDepartmentName: ''
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    departmentId() {
      return this.$route.query.departmentId
    },
    sourceType() {
      return this.$route.query.sourceType
    },
    sourceId() {
      return this.$route.query.sourceId
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == '/') {
        vm.hasPath = from.path;
      }
    });
  },
  watch: {
    selectDepartmentId() {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据

      wx.miniProgram.postMessage({
        data: {
          share: {
            title: this.title,
            imageUrl: '',
            path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/zonePage?id=${this.$route.query.id}&departmentId=${this.selectDepartmentId}&sourceType=7`)}`,
            contentId: ''
          }
        }
      })
    }
  },
  created() {
    if(this.departmentId) {
      this.selectDepartmentId = this.departmentId;
    }
    this.getDepartmentList();
  },
  activated(){
    this.getZoneInfo();
  },
  methods: {
    async getZoneInfo() {
      let res = await this.$axios.post('/Api/Api/Web/Zone/GetZ', {
        ZId: this.id
      });
      let data = res.Data;
      this.title = data.Name;
      this.type = data.Type;

      wx.miniProgram.postMessage({
        data: {
          share: {
            title: this.title,
            imageUrl: '',
            path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/zonePage?id=${this.$route.query.id}&departmentId=${this.selectDepartmentId}&sourceType=7`)}`,
            contentId: ''
          }
        }
      })
      
      this.BuriedPoint(6, this.title, '', this.$route.fullPath.replace(/&stack-key=[^&]*/, ''), this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    },
    mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Zone/GetList', {
          ZId: this.id,
          SubId: this.selectDepartmentId,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then(res => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr)
          this.$forceUpdate()
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        })
      }, 200);
    },
    getDepartmentList() {
      this.$axios.get('/Api/Api/Web/Customer/GetDitWebCodeList?type=1').then(res => {
        this.departmentList = res.Data;
        if(this.departmentId) {
          const item = this.departmentList.find(item => item.Id == this.departmentId);
          if(item) {
            this.selectDepartmentName = item.Name;
          }
        }
      })
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/home');
        return;
      }
      this.$router.go(-1);
    },
    showDepartment() {
      this.showDepartmentPopover = true;
      this.tempSelectDepartmentId = this.selectDepartmentId;
    },
    onScreenCancel() {
      this.showDepartmentPopover = false;
      this.tempSelectDepartmentId = 0;
      this.tempSelectDepartmentName = '';
    },
    // 直播筛选确认选择科室
    onScreenConfirm() {
      this.showDepartmentPopover = false;
      this.selectDepartmentId = this.tempSelectDepartmentId;
      this.selectDepartmentName = this.tempSelectDepartmentName;
    },
    selectDepartment(id, name) {
      this.tempSelectDepartmentId = id;
      this.tempSelectDepartmentName = name;
    },
    toZoneDetails(id, contentId) {
      this.$router.push({
        path: 'zoneDetails',
        query: {
          id: id,
          sourceType: 11,
          sourceId: contentId
        }
      });
    },
    contentClick(info, id) {
      if(info.Type == 1 || info.Type == 2) {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: info.Id,
            type: info.Type,
            sourceType: 11,
            sourceId: id
          }
        });
      } else if(info.Type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: info.Id,
            sourceType: 11,
            sourceId: id
          }
        });
      } else if(info.Type == 4) {
        this.$router.push({
          path: 'activityDetails',
          query: {
            id: info.Id,
            sourceType: 11,
            sourceId: id
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F9F9F9;
}
.navigationBar {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #F3F3F3;
  box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 6px 0px;
  .nav-left {
    width: 80px;
    .arrow-left {
      display: block;
      width: 22px;
    }
  }
  .nav-title {
    flex: 1;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .nav-right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 25px;
    font-size: 12px;
    color: #EB1701;
    border: 1px solid #EB1701;
    border-radius: 25px 0 25px 25px;
    padding: 0 6px;
    box-sizing: border-box;
    span {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    img {
      display: block;
      width: 10px;
      margin-left: 4px;
    }
  }
  .picker_content {
    padding: 20px 6px;
    .pickerBox {
      display: flex;
      flex-wrap: wrap;
    }
    .picker_block {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(calc(100% / 3) - 12px);
      height: 38px;
      text-align: center;
      border: 1px solid rgba(153, 153, 153, 0.5);
      box-sizing: border-box;
      margin: 0px 6px 15px;
      border-radius: 4px;
      color: #333333;
      font-size: 14px;
    }
    .active {
      border: none;
      color: #C70C3C;
      background-image: url('../../assets/images/select_system_btn@2x.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
.mescroll {
  position: fixed;
  top: 50px;
  bottom: 0;
  height: auto;
  padding: 15px;
  box-sizing: border-box;
}
.list {
  flex: 1;
  // padding: 15px;
  overflow: auto;
  .item {
    padding: 5px;
    border-radius: 12px;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
    .cover {
      display: block;
      width: 100%;
      border-radius: 12px;
    }
    .info {
      position: relative;
      padding: 5px;
      .title{
        width: 80%;
        font-size: 14px;
        font-weight: bold;
        color: #3D3D3D;
        margin-bottom: 4px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;    /* 显示行数，2就是两行 */
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .time{
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        color: #898989;
      }
      .viewBtn {
        position: absolute;
        top: 15px;
        right: 10px;
        border: none;
        width: 50px;
        height: 26px;
        line-height: 26px;
        border-radius: 26px;
        text-align: center;
        font-size: 14px;
        color: #FFFFFF;
        // background-color: #EB1701;
        background: linear-gradient(to top, #EB1700 38%, #FEE9E7 100%);
      }
    }
  }
  .item:not(:last-of-type) {
    margin-bottom: 15px;
  }

  .item1 {
    border-radius: 12px;
    // background-color: #EB1701;
    background: linear-gradient(to right, #EB1700 20%, #FEE9E7 100%);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
    overflow: hidden;
    .titleBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px 8px 15px;
      color: #FFFFFF;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
      .enter {
        height: 20px;
        line-height: 20px;
        border-radius: 20px;
        padding: 0 5px;
        background: rgba(255, 255, 255, 0.8);
        font-size: 12px;
        font-weight: bold;
        color: #EB1700;
      }
    }
    .relatedContent {
      background-color: #FFFFFF;
      border-radius: 12px 12px 0 0;
      padding: 10px;
      .relatedItem {
        display: flex;
        .cover {
          display: block;
          width: 45%;
          border-radius: 10px;
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          padding: 8px 0px 8px 8px;
          .title {
            font-size: 12px;
            font-weight: bold;
            color: #000000;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;    /* 显示行数，2就是两行 */
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .doctor {
            font-size: 10px;
            color: #898989;
          }
        }
      }
      .relatedItem:not(:last-of-type) {
        margin-bottom: 8px;
      }
    }
  }
  .item1:not(:last-of-type) {
    margin-bottom: 15px;
  }
}
</style>